import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: () => import('../views/Impressum.vue'),
    meta: { breadcrumbName: 'Impressum' }
  },
  {
    path: '/agb',
    name: 'Agb',
    component: () => import('../views/Agb.vue'),
    meta: { breadcrumbName: 'AGB' }
  },
  {
    path: '/datenschutz',
    name: 'Datenschutz',
    component: () => import('../views/Datenschutz.vue'),
    meta: { breadcrumbName: 'Datenschutz' }
  },
  {
    path: '/urlaubsreisen',
    name: 'Urlaubsreisen',
    component: () => import('../views/Urlaubsreisen.vue'),
    meta: { breadcrumbName: 'Urlaubsreisen' }
  },
  {
    path: '/studienreisen',
    name: 'Studienreisen',
    component: () => import('../views/Studienreisen.vue'),
    meta: { breadcrumbName: 'Studienreisen' }
  },
  {
    path: '/specials',
    name: 'Specials',
    component: () => import('../views/Specials.vue'),
    meta: { breadcrumbName: 'Specials' }
  },
  {
    path: '/ueber-uns',
    name: 'UeberUns',
    component: () => import('../views/UeberUns.vue'),
    meta: { breadcrumbName: 'Über uns' }
  },
  {
    path: '/reisethema-fluege-mietauto',
    name: 'ReiseThFluege',
    component: () => import('../views/ReiseThFluege.vue'),
    meta: { breadcrumbName: 'Flüge & Mietauto', serviceType: 'Flüge & Mietauto' }
  },
  {
    path: '/reisethema-autoreisen-eigenreise',
    name: 'ReiseThAuto',
    component: () => import('../views/ReiseThAuto.vue'),
    meta: { breadcrumbName: 'Autoreisen & Eigenreise', serviceType: 'Autoreisen & Eigenreise' }
  },
  {
    path: '/reisethema-wellness-fitness-kuren',
    name: 'ReiseThWellness',
    component: () => import('../views/ReiseThWellness.vue'),
    meta: { breadcrumbName: 'Wellness, Fitness & Kuren', serviceType: 'Wellness, Fitness & Kuren' }
  },
  {
    path: '/reisethema-ferienhauser-ferienwohnungen',
    name: 'ReiseThFerienha',
    component: () => import('../views/ReiseThFerienha.vue'),
    meta: { breadcrumbName: 'Ferienhäuser & Ferienwohnungen', serviceType: 'Ferienhäuser & Ferienwohnungen' }
  },
  {
    path: '/reisethema-cluburlaub-and-more',
    name: 'ReiseThCluburluab',
    component: () => import('../views/ReiseThCluburluab.vue'),
    meta: { breadcrumbName: 'Cluburlaub & More', serviceType: 'Cluburlaub & More' }
  },
  {
    path: '/reisethema-lunux-und-ferienreisen',
    name: 'ReiseThLuxus',
    component: () => import('../views/ReiseThLuxus.vue'),
    meta: { breadcrumbName: 'Luxus- & Ferienreisen', serviceType: 'Luxus- & Ferienreisen' }
  },
  {
    path: '/reisethema-hotels',
    name: 'ReiseThHotels',
    component: () => import('../views/ReiseThHotels.vue'),
    meta: { breadcrumbName: 'Hotels', serviceType: 'Hotels' }
  },
  {
    path: '/reisethema-kreuzfahrten',
    name: 'ReiseThKreuzfahrten',
    component: () => import('../views/ReiseThKreuzfahrten.vue'),
    meta: { breadcrumbName: 'Kreuzfahrten', serviceType: 'Kreuzfahrten' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
